import { Injectable } from '@angular/core';
import { RequestService } from '../request/request.service';

@Injectable({
  providedIn: 'root'
})
export class ModalAtualizacaoCadastroService {

  constructor(private _requestService: RequestService) {}

  verificarAtualizacaoUsuario(companyID, restrictionKey, userID) {
    let header = {
      'Content-Type': 'application/json',
      restrictionKey: restrictionKey != null ? restrictionKey : '',
      companyID: companyID != null ? companyID : '',
    };
    return this._requestService.requestMethod(`user/api/User/${userID}/is-update-required`,'GET', true, null,header );
  }

  atualizarUsuario(companyID, restrictionKey, data) {
    let header = {
      'Content-Type': 'application/json',
      restrictionKey: restrictionKey != null ? restrictionKey : '',
      companyID: companyID != null ? companyID : '',
    };
    return this._requestService.requestMethod(`user/api/User/self`,'PUT', true, data, header );
  }
}
